// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pre[data-v-1f6439f4] {\n  white-space: pre;\n}\n.home-content-wrap[data-v-1f6439f4] {\n  max-width: 1100px;\n}\n.preview-image[data-v-1f6439f4] {\n  display: block;\n  width: 100px;\n  height: 100px;\n  border: 0;\n  object-fit: cover;\n}\n", ""]);
// Exports
module.exports = exports;
